import { Injectable, Inject } from '@angular/core';
import { appDataServiceToken, AppDataService } from 'dashboard/services/app-data.service';
import { Resolve } from '@angular/router';
import { Observable, from } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AppInitResolver implements Resolve<void> {
	constructor (
		@Inject(appDataServiceToken) private appDataService: AppDataService
	) {}

	public resolve (): Observable<void> {
		return from(this.appDataService.initAppData());
	}
}
